import { useQuery } from '@tanstack/react-query'
import { getActiveAnnouncementsKey } from 'common/constants/queryKeys'

import { getActiveAnnouncements } from '.'
import { ActiveAnnouncementsResponse } from './types'

export const useGetActiveAnnouncements = () => {
  return useQuery<ActiveAnnouncementsResponse>({
    queryKey: getActiveAnnouncementsKey(),
    queryFn: async () => {
      const { data } = await getActiveAnnouncements()
      return data.data
    },
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
